// extracted by extract-css-chunks-webpack-plugin
module.exports = {"iconError":"ErrorPage__iconError--BYYvT"};